import React, { Component } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Login from './pages/authentication/Login'
import Register from './pages/authentication/Register'
import SignUp from './pages/signup'
import CheckEmail from './pages/check-verify-email-code'
import RenewPassword from './pages/renew-password'
import Main from './pages/main'
import PrivateRoute from './components/private-route'
import Purpose from './pages/purpose'
import AppSumoSignUp from './pages/appsumo-signup/index'
import ForgotPassword from './pages/authentication/ForgotPassword'
import ChangePassword from './pages/authentication/ChangePassword'
import Policies from './pages/policies'
import ProjectOnLife from './pages/projectonlife-signup'
import Integration from './pages/integration-reroute'
import Redirect from './pages/redirect'
import MaintenancePage from 'src/pages/maintenance'
import IntercomIntegration from 'src/pages/intercom-integration'

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          {/* <Route path="/" component={MaintenancePage} /> */}

          <Route path="/login" component={Login} />
          <Route path="/register" component={Register} />
          <Route path="/integration/:token?" component={Integration} />

          <Route path="/renew-password/" component={RenewPassword} />
          <Route exact path="/signup/:id?" component={SignUp} />
          <Route
            exact
            path="/hello-sumo-lings/:id?"
            component={AppSumoSignUp}
          />
          <Route exact path="/projectonlife" component={ProjectOnLife} />
          <Route path="/checkEmail" component={CheckEmail} />

          <Route path="/forgot-password" component={ForgotPassword} />
          <Route
            path="/change-password/:linkCode?"
            component={ChangePassword}
          />
          <Route path="/policies" component={Policies} />
          <Route path="/purpose" component={Purpose} />
          <Route path="/redirect/:url*" component={Redirect} />
          <Route path="/intercom-integration" component={IntercomIntegration} />
          <PrivateRoute path="/" component={Main} />
        </Switch>
      </BrowserRouter>
    )
  }

  componentWillMount() {
    window.CONSTANTS = {
      TIME_ZONE: 'Europe/Istanbul',
      DATE_FORMAT: 'DD-M-YYYY',
      NAME: ' ',
      SUR_NAME: ' ',
      EMAIL: ' ',
      CUSTOM_DOMAIN: null,
      LOCALIZATION_STRINGS: {},
      ID: '',
      SECRET_KEY: '',
    }
  }
}

export default App
